/* Devikala V3 bag. Opens from the bag icon / "View bag" / after Add to bag; changes quantities with /cart/change.js.
   Only the item list and totals are refreshed, the checkout button is never replaced, so GoKwik keeps its hook.
   No prices, fees or discounts are calculated here. */
(function(){
  if(window.DvkBag&&window.DvkBag.__v) return;
  var lastFocus=null, busy=false;

  function root(){ return document.querySelector('[data-dvk-bag]:not(.is-page)')||document.querySelector('[data-dvk-bag].is-page'); }
  function drawer(){ return document.querySelector('[data-dvk-bag]:not(.is-page)'); }

  function setCounts(n){
    var t=n>99?'99+':String(n);
    document.querySelectorAll('m-cart-count,.m-cart-count,[data-cart-count]').forEach(function(el){
      el.textContent=t; el.classList.toggle('m:hidden',n===0);
    });
    document.querySelectorAll('.dvk-hdr__bag').forEach(function(a){ a.setAttribute('aria-label','Bag, '+n+(n===1?' item':' items')); });
  }

  function refresh(){
    var r=root(); if(!r) return Promise.resolve();
    var id=r.getAttribute('data-section'), base=r.getAttribute('data-url')||'/';
    var url=base+(base.indexOf('?')>-1?'&':'?')+'sections='+encodeURIComponent(id);
    return fetch(url,{credentials:'same-origin'}).then(function(res){ return res.json(); }).then(function(j){
      var html=j&&j[id]; if(!html) return;
      var doc=new DOMParser().parseFromString(html,'text/html');
      var nb=doc.querySelector('[data-dvk-bag-body]'), ob=r.querySelector('[data-dvk-bag-body]');
      if(nb&&ob) ob.innerHTML=nb.innerHTML;
      [['[data-dvk-bag-count]'],['[data-dvk-bag-fcount]'],['[data-dvk-bag-ftotal]']].forEach(function(s){
        var a=doc.querySelector(s[0]), b=r.querySelector(s[0]); if(a&&b) b.textContent=a.textContent;
      });
      var nr=doc.querySelector('[data-dvk-bag]'), n=nr?parseInt(nr.getAttribute('data-count'),10)||0:0;
      r.setAttribute('data-count',n);
      var foot=r.querySelector('[data-dvk-bag-foot]'); if(foot) foot.hidden=n===0;
      setCounts(n);
    }).catch(function(){});
  }

  // The theme's page-transition layer fades in on any link click and waits for the next page.
  // The bag keeps you on the page, so fade that layer back out, otherwise it hides the page behind the bag.
  function clearTransition(){
    document.querySelectorAll('.m-page-transition').forEach(function(el){ el.classList.remove('fade-in'); el.classList.add('fade-out'); });
  }
  function open(doRefresh){
    var d=drawer(); if(!d) { window.location.href='/cart'; return; }
    clearTransition(); setTimeout(clearTransition,30); setTimeout(clearTransition,250);
    lastFocus=document.activeElement;
    d.hidden=false;
    document.documentElement.classList.add('dvk-bag-lock');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ d.classList.add('is-open'); }); });
    var x=d.querySelector('.dvk-bag__x'); if(x) setTimeout(function(){ x.focus({preventScroll:true}); },60);
    if(doRefresh!==false) refresh();
    document.dispatchEvent(new CustomEvent('dvk:bag:open'));
  }
  function close(){
    var d=drawer(); if(!d||d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('dvk-bag-lock');
    var done=function(){ d.hidden=true; };
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else setTimeout(done,280);
    if(lastFocus&&lastFocus.focus) lastFocus.focus({preventScroll:true});
  }

  function change(item,qty){
    if(busy) return; busy=true;
    item.setAttribute('aria-busy','true');
    var err=item.querySelector('[data-dvk-line-err]'); if(err) err.hidden=true;
    fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:item.getAttribute('data-key'),quantity:qty})})
      .then(function(res){ return res.json().then(function(j){ if(!res.ok) throw j; return j; }); })
      .then(function(){ return refresh(); })
      .catch(function(j){
        item.removeAttribute('aria-busy');
        if(err){ err.hidden=false; err.textContent=(j&&(j.description||j.message))||'Could not update your bag. Please try again.'; }
      })
      .then(function(){ busy=false; });
  }

  // Open the bag from the bag icon, "View bag" links and anything marked data-dvk-bag-open.
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-dvk-bag-open],a[href="/cart"],a[href$="/cart"],.dvk-hdr__bag');
    if(t&&drawer()&&!t.closest('[data-dvk-bag]')){ e.preventDefault(); e.stopPropagation(); open(true); return; }
    var b=e.target.closest('[data-dvk-bag]'); if(!b) return;
    // A tap anywhere outside the bag panel closes it.
    if(!b.classList.contains('is-page')&&!e.target.closest('[data-dvk-bag-panel]')){ e.preventDefault(); close(); return; }
    if(e.target.closest('[data-dvk-bag-close]')){ e.preventDefault(); close(); return; }
    var q=e.target.closest('[data-dvk-qty]');
    if(q){ var it=q.closest('.dvk-bag__item'); if(it){ e.preventDefault(); change(it,Math.max(0,parseInt(q.getAttribute('data-dvk-qty'),10)||0)); } }
  },true);

  document.addEventListener('keydown',function(e){
    var d=drawer(); if(!d||d.hidden) return;
    if(e.key==='Escape'){ close(); return; }
    if(e.key!=='Tab') return;
    var f=d.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
    f=Array.prototype.filter.call(f,function(el){ return el.offsetParent!==null; });
    if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey&&document.activeElement===last){ e.preventDefault(); first.focus(); }
  });

  // Coming back to a page from the browser cache: show the current bag.
  window.addEventListener('pageshow',function(e){ if(e.persisted) refresh(); });

  window.DvkBag={__v:1,ready:function(){ return !!drawer(); },open:open,close:close,refresh:refresh};
})();
